<template>
  <div class="navbar">
    <template v-if="isLogin">
      <div class="nav_left">
        <img src="@/assets/icon_4.png" alt="">
        <img src="@/assets/icon_5.png" alt="">
        <div class="nav_tab_box" v-if="currentPath !== '/'">
          <div v-for="(item, index) in nav_tab" :key="index" :class="{ active: currentPath === item.path }"
            @click="handleGoPath(item.path)">
            {{ item.name }}
          </div>
        </div>
      </div>
      <div>
        <el-dropdown @command="handleCommand">
          <span class="userbox el-dropdown-link">
            <div>
              <img src="@/assets/icon_2.png" alt=""></img>
            </div>
            {{ username }}
          </span>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item command="1">正畸报告</el-dropdown-item>
              <el-dropdown-item command="2">使用协议</el-dropdown-item>
              <el-dropdown-item command="3">关于我们</el-dropdown-item>
              <el-dropdown-item command="4">修改密码</el-dropdown-item>
              <el-dropdown-item command="5">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </template>
    <template v-else>
      <span></span>
      <span class="not_login" @click="handleGoLogin">请登录</span>
    </template>
  </div>

  <!-- 登录弹窗 -->
  <el-dialog v-model="dialogVisible" width="300" :close-on-click-modal="false" :before-close="handleLoginDialogClose">
    <el-form ref="loginFormRef" :model="loginForm" :rules="loginRules" label-width="0px">
      <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
        <el-tab-pane label="登录" name="1">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" placeholder="请输入密码" type="password" show-password></el-input>
          </el-form-item>
          <el-form-item>
            <el-button style="width: 100%;" type="primary" @click="handleLogin">登录</el-button>
          </el-form-item>
        </el-tab-pane>
        <el-tab-pane label="注册" name="2">
          <el-form-item prop="username">
            <el-input v-model="loginForm.username" placeholder="请输入账号" />
          </el-form-item>
          <el-form-item prop="password">
            <el-input v-model="loginForm.password" placeholder="请输入密码" type="password" show-password></el-input>
          </el-form-item>
          <!-- <el-form-item prop="yaoqingma">
            <el-input v-model="loginForm.yaoqingma" placeholder="请输入邀请码"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button style="width: 100%;" type="primary" @click="handleRegister">注册</el-button>
          </el-form-item>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </el-dialog>


  <!-- 修改密码弹窗 -->
  <el-dialog v-model="changePasswordVisible" title="修改密码" width="300" :close-on-click-modal="false"
    :before-close="handleChangePasswordDialogClose">
    <el-form ref="changePasswordFormRef" :model="changePasswordForm" :rules="changePasswordRules" label-width="0px">
      <el-form-item prop="password">
        <el-input v-model="changePasswordForm.password" placeholder="请输入旧密码" type="password" show-password></el-input>
      </el-form-item>
      <el-form-item prop="newPassword">
        <el-input v-model="changePasswordForm.newPassword" placeholder="请输入新密码" type="password"
          show-password></el-input>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <el-input v-model="changePasswordForm.confirmPassword" placeholder="请确认新密码" type="password"
          show-password></el-input>
      </el-form-item>
      <el-form-item>
        <el-button style="width: 100%;" type="primary" @click="handleChangePassword">修改密码</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>


  <!-- 使用协议、关于我们弹窗 -->
  <el-dialog v-model="protocolVisible" width="80%" top="1vh" :before-close="handleProtocolDialogClose">
    <div v-html="protocolContent"></div>
  </el-dialog>

</template>

<script setup>
import { ElMessage } from 'element-plus';
import { computed, reactive, ref, getCurrentInstance, watch, onMounted } from 'vue';
import axios from "@/utils/request";
import router from '@/router';
import store from '@/store';
import { ElMessageBox } from 'element-plus';

const activeName = ref('1')

const dialogVisible = ref(false);
const showButton = ref(true);
const loginFormRef = ref(null);
const loginForm = reactive({
  username: '',
  password: '',
  yaoqingma: '',
});
const loginRules = reactive({
  username: { required: true, message: '请输入账号', trigger: 'blur' },
  password: { required: true, message: '请输入密码', trigger: 'blur' },
  // yaoqingma: { required: false, message: '请输入邀请码', trigger: 'blur' }
});

// 从store获取登录状态和用户名
const isLogin = computed(() => store.getters.isLogin);
const username = computed(() => store.state.username);
// 当前路径，用于导航菜单选中效果
const currentPath = ref('/');

// 组件挂载时检查登录状态
onMounted(() => {
  // 已在store初始化时从localStorage恢复状态，这里可以添加其他初始化逻辑
});

// 头部菜单
const nav_tab = reactive([
  {
    name: '首页',
    path: '/',
  },
  {
    name: '我是医生',
    path: '/doctor',
  },
  {
    name: '我是患者',
    path: '/patient',
  },
  {
    name: '病例库',
    path: '/case',
  }
])

// 监听route变化, 切换菜单
watch(() => router.currentRoute.value, (e) => {
  console.log(e.name, '路由变化');
  currentPath.value = e.path;

  // 通知父组件是否显示tab切换（首页不显示）
  const parent = getCurrentInstance()?.parent?.proxy;
  if (parent && typeof parent.showTabs === 'function') {
    parent.showTabs(e.path !== '/');
  }
}, { immediate: true })

// 切换菜单
const handleGoPath = (path) => {
  router.push(path);

  // 点击首页时隐藏tab切换
  const parent = getCurrentInstance()?.parent?.proxy;
  if (parent && typeof parent.showTabs === 'function') {
    parent.showTabs(path !== '/');
  }
}

// 下拉菜单
const handleCommand = (command) => {
  console.log(command, '下拉菜单');
  switch (command) {
    case '1':
      console.log('正畸报告');
      router.push('/report');
      break;
    case '2':
      console.log('使用协议');
      getProtocolContent('/api/xieyi/1/')
      break;
    case '3':
      console.log('关于我们');
      getProtocolContent('/api/guanyuwomen/1/')
      break;
    case '4':
      console.log('修改密码');
      changePasswordVisible.value = true;
      break;
    case '5':
      ElMessageBox.confirm('确定退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 调用store的logout action退出登录
        store.dispatch('logout').then(() => {
          handleLoginDialogClose();
          router.replace('/');
          ElMessage.success('退出登录成功');
        });
      }).catch(() => {
        // 用户点击取消，不执行任何操作
      });
      break;
    default:
      break;
  }
}


// 请登录
const handleGoLogin = () => {
  dialogVisible.value = true;
}

// 登录
const handleLogin = () => {
  loginFormRef.value.validate((valid) => {
    if (valid) {
      store.dispatch('login', {
        username: loginForm.username,
        password: loginForm.password
      }).then((res) => {
        ElMessage.success('登录成功');
        dialogVisible.value = false;
        // 重置登录表单
        loginForm.username = '';
        loginForm.password = '';
        console.log(res, '登录成功');
      }).catch(err => {
        console.log(err, '登录失败');
      })
    }
  });
}

// 注册
const handleRegister = () => {
  loginFormRef.value.validate((valid) => {
    if (valid) {
      store.dispatch('register', {
        username: loginForm.username,
        password: loginForm.password,
        yaoqingma: loginForm.yaoqingma || ''
      }).then(res => {
        console.log(res, '注册成功');
        ElMessage.success('注册成功，请登录');
        // 注册成功后切换到登录标签
        activeName.value = '1';
      }).catch(err => {
        console.log(err, '注册失败');
      })
    }
  });
}

// 切换tab
const handleClick = (tab, event) => {
  activeName.value = tab.name;
  clearForm();
  // if (tab.name === '2') {
  //   loginRules.yaoqingma.required = true;
  // } else {
  //   loginRules.yaoqingma.required = false;
  // }
}

// 关闭弹窗
const handleLoginDialogClose = () => {
  activeName.value = '1';
  dialogVisible.value = false;
  clearForm();
  // 只有在未登录状态下关闭弹窗时才清空
  if (!isLogin.value) {
    clearForm();
  }
}

// 清空表单
const clearForm = () => {
  loginForm.username = '';
  loginForm.password = '';
  loginForm.yaoqingma = '';

  changePasswordForm.password = '';
  changePasswordForm.newPassword = '';
  changePasswordForm.confirmPassword = '';
}


// 修改密码弹窗
const changePasswordVisible = ref(false);
const changePasswordFormRef = ref(null);
const changePasswordForm = reactive({
  password: '',
  newPassword: '',
  confirmPassword: '',
});
const changePasswordRules = reactive({
  password: { required: true, message: '请输入当前密码', trigger: 'blur' },
  newPassword: { required: true, message: '请输入新密码', trigger: 'blur' },
  confirmPassword: {
    required: true,
    message: '请确认新密码',
    trigger: 'blur',
    validator: (rule, value, callback) => {
      // 新密码与确认密码一致性校验
      if (value !== changePasswordForm.newPassword) {
        callback(new Error('两次输入的新密码不一致'));
      } else {
        callback();
      }
    }
  }
});
const handleChangePassword = () => {
  changePasswordFormRef.value.validate((valid) => {
    if (valid) {
      // 增加新旧密码一致性校验
      if (changePasswordForm.password === changePasswordForm.newPassword) {
        ElMessage.error('新密码不能与当前密码相同');
        return;
      }

      // 按照接口要求传递参数
      axios.post(`/api/user/xiugaimima/`, {
        user_id: store.state.userId,
        old_password: changePasswordForm.password,
        new_password1: changePasswordForm.newPassword,
        new_password2: changePasswordForm.confirmPassword
      }).then(res => {
        console.log(res, '修改密码成功');
        ElMessage.success('修改密码成功');
        changePasswordVisible.value = false;
        clearForm();
      }, err => {
        console.log(err, '修改密码失败');
        // 根据错误信息提供更具体的提示
        if (err.response && err.response.data && err.response.data.msg) {
          ElMessage.error(err.response.data.msg);
        } else {
          ElMessage.error('修改密码失败，请检查当前密码是否正确');
        }
      })
    }
  });
}
const handleChangePasswordDialogClose = () => {
  changePasswordVisible.value = false;
  clearForm();
}


// 使用协议、关于我们弹窗
const protocolVisible = ref(false);
const protocolContent = ref('');
const getProtocolContent = (url) => {
  axios.get(url).then(res => {
    console.log(res, '使用协议');
    protocolContent.value = res.results.text;
    protocolVisible.value = true;
  }, err => {
    console.log(err, '使用协议失败');
  })
}
const handleProtocolDialogClose = () => {
  protocolVisible.value = false;
  protocolContent.value = '';
}

// 获取验证码
const countTime = ref(60);
const handleGetCode = () => {
  if (!showButton.value) return;
  if (!loginForm.username) {
    ElMessage.warning('请输入手机号');
    return;
  }
  let regex = /^(?:(?:\+|00)86)?1\d{10}$/;
  if (!regex.test(loginForm.username)) {
    ElMessage.warning('请输入正确的手机号');
    return;
  }
  axios.get('/api/send_msg/', {
    params: {
      tel: loginForm.username,
    }
  }).then(
    (res) => {
      console.log(res, '获取验证码');
      countDown();
    },
    (err) => {
      console.log(err, '验证码错误');
    }
  );
};

const timer = ref(null);
const countDown = () => {
  clearInterval(timer.value);
  timer.value = null;
  timer.value = setInterval(() => {
    let time = countTime.value;
    time = time - 1;
    countTime.value = time;
    if (time == 0) {
      showButton.value = true;
      countTime.value = 60;
      clearInterval(timer.value);
      timer.value = null;
    } else {
      showButton.value = false;
    }
  }, 1000);
}

onMounted(() => {
  console.log("NavBar mounted");
  // 登录状态已通过store的getter自动同步，无需额外操作
})

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.navbar {
  width: 100vw;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 70px 0 30px;

  .nav_left {
    display: flex;
    align-items: center;

    >img:nth-child(1) {
      width: 36px;
      height: 26px;
      margin-right: 10px;
    }

    >img:nth-child(2) {
      height: 21px;
      object-fit: contain;
    }

    .nav_tab_box {
      display: flex;
      align-items: center;

      div {
        width: 100px;
        text-align: center;
        cursor: pointer;
        user-select: none;
        position: relative;
        transition: all 0.3s ease;
      }

      div:hover {
        color: #409eff;
      }

      div.active {
        color: #409eff;
        font-weight: bold;
      }

      div.active::after {
        content: '';
        position: absolute;
        bottom: -5px;
        left: 50%;
        transform: translateX(-50%);
        width: 20px;
        height: 3px;
        background-color: #409eff;
        border-radius: 2px;
      }
    }
  }

  .userbox {
    display: flex;
    align-items: center;
    font-size: 16px;
    color: #333333;
    cursor: pointer;
    outline: none;

    div {
      width: 30px;
      height: 30px;
      border-radius: 50%;
      margin-right: 10px;
      display: flex;
      align-items: center;

      img {
        width: 17px;
        height: 17px;
      }
    }
  }

  .not_login {
    font-size: 16px;
    color: #333333;
    line-height: 60px;
    cursor: pointer;
    user-select: none;
  }
}
</style>
